<template>
  <div class="home">
    <div class="flex-grid">
      <div class="grid-title">
        <h1>Nuevo usuario</h1>
      </div>
      <adminCreateForm :adminId="adminId" />
    </div>
  </div>
</template>

<script>
import adminCreateForm from '@/components/CreateAdminUserForm.vue'

export default {
  name: 'createAdminUser',
  props: {
    adminId: {
      type: Number,
      required: true
    }
  },
  components: {
    adminCreateForm
  },
}
</script>